var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheInteractiveSvg',{ref:"interactiveSvg",attrs:{"svg-url":_vm.svgUrl,"interactive-element-ids":_vm.svgTargetElementIds,"colored-elements":_vm.markerColors,"disabled":_vm.zoomTrackerAnyGestureActive},on:{"enter-element":_vm.showElementPreview,"leave-element":_vm.hideElementPreview,"select-element":_vm.showElement}})
}
var staticRenderFns = []

export { render, staticRenderFns }